mama-share {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1rem;

  &.container {
    margin-bottom: 0;
    margin-top: 0;
  }

  a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0 0.5rem;
    background-color: $white;
  }

  span {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding-right: 0.5rem;
    font-weight: $font-weight-bold;
  }

  svg {
    width: 2rem;
    height: 2rem;
    fill: var(--theme-color, $mm-petrol);
  }
}
